import React, { useState } from 'react';
import Collapsible from './Collapsible';

const FaqItems = ({ faqItemsData }) => {
  return (
    <>
      {faqItemsData.map((item, index) => (
        <Collapsible
          className="collapsible-header"
          transitionDuration="0.2"
          label={item.faqItemTitle}
          key={item.faqItemTitle + index}
        >
          {item.faqItemText}
        </Collapsible>
      ))}
    </>
  );
};

export default FaqItems;
